import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

export const useResetCompanyProfile = (): VoidFunction => {
  const queryClient = useQueryClient();

  const handleResetCompanyProfileQueries = useCallback(() => {
    void queryClient.invalidateQueries({
      queryKey: ['companyProfile'],
      exact: false,
    });
  }, [queryClient]);

  return handleResetCompanyProfileQueries;
};
